export const LIKER_TYPES = Object.freeze({
  USER: 'user',
  ORGANISATION: 'organisation',
})

export const LIKED_TYPES = Object.freeze({
  VACANCY: 'vacancy',
  ONE_DAY_VACANCY: 'one_day_vacancy',
  ORGANISATION: 'organisation',
  USER: 'user',
  GROUP_PROJECT: 'group_project',
  CALENDAR_ITEM: 'calendar_item',
  IMPACT_DAY: 'impact_day',
})
